import React from "react";
import "./style.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import AccountDataPanel from "./AccountDataPanel";
import useMyAccount from "./hooks/useMyAccount";
import AccountDocPanel from "./AccountDocPanel";
import AccountCardPanel from "./AccountCard/AccountCardPanel";
import { useSelector } from "react-redux";
import { State } from "../../store";

const MyAccount: React.FC = () => {
  const isDesktop = useDesktopSize();
  const ecardActive = useSelector((state: State) => state.config.configuration.ecard_showCode);


  useMyAccount();

  return (
    <div className="panel-account">
      <AccountDataPanel />
      <div className="body-content flex-between">
        <div
          className={
            ecardActive === true
              ? "ticket-box shadow border"
              : "full-ticket-box ticket-box shadow border"
          }>
          <AccountDocPanel />
        </div>
        {ecardActive && <div className="card-box shadow border">
          <AccountCardPanel />
        </div>}
      </div>
    </div>
  );
};

export default MyAccount;
